(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-brand"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.dfRevealReady) return;
  window.dfRevealReady = true;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px' }
  );

  function scan(root) {
    (root || document).querySelectorAll('.df-rv:not(.is-in)').forEach(function (el) {
      observer.observe(el);
    });
  }

  scan();
  document.addEventListener('DOMContentLoaded', function () {
    scan();
  });
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
